// temporary solution for legal user locations
const LEGAL_STATES = [
  'AZ',
  'AK',
  'AR',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'IL',
  'IA',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MS',
  'MN',
  'MO',
  'MT',
  'NV',
  'NH',
  'NJ',
  'NM',
  'ND',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'SD',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
];

export const getIsUserInLegalMarket = (state: string): boolean => LEGAL_STATES.includes(state);
